var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.packageItems && _vm.packageItems.length)?_c('div',{staticClass:"flex flex-col gap-4"},[_c('ProductAnchorTitle',{attrs:{"title":_vm.$t('Delivery Package')}}),_vm._v(" "),_c('IconicList',{attrs:{"items":_vm.packageItems}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }